import { Injectable, resolveForwardRef } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Test} from '../components/order-entry/test';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  constructor(private http: HttpClient) {}
  urlEndPoint = environment.endPoint;

  async getTest(term: string) {
    if (term === '' || term.length < 2) {
      return of([]);
    }

    term = term.toLowerCase();
    
    const tests = await this.getAllTests();

    return tests.filter( (test) => {
      return (
        test.id.toLowerCase().includes(term) ||
        test.description.toLowerCase().includes(term) ||
        test.specimenId.toLowerCase().includes(term)
      )
    })

  }

  async getTestByCode(term: string){

    term = term.toUpperCase();
    
    const tests = await this.getAllTests();

    let result = tests.filter((test) => test.id == (term))

    if(result.length != 0){
      return result;
    }

    const profiles = await this.getAllProfiles();
    result = profiles.filter((test) => test.id == (term))

    if(result.length != 0){
      return result;
    }

    return [];
  }

  async getAllTests(){
    let tests = JSON.parse(localStorage.getItem('tests'));
    let dtests =  JSON.parse(localStorage.getItem('dtests'));
    if (!tests){
      tests = await this.http.get<any>(this.urlEndPoint + '/api/test').toPromise();
      dtests = await this.http.get<any>(this.urlEndPoint + '/api/test-dynamic').toPromise();
      localStorage.setItem('tests', JSON.stringify(tests))
      localStorage.setItem('dtests', JSON.stringify(dtests))

    }
    return tests.concat(dtests);
  }

  async getAllProfiles(){
    let profiles = JSON.parse(localStorage.getItem('profiles'));
    if (!profiles){
      profiles = await this.http.get<any>(this.urlEndPoint + '/api/profile').toPromise();
      localStorage.setItem('profiles', JSON.stringify(profiles))

    }
    return profiles;
  }

  async getAllTestsFiltered( serviceType, priorityLevel ){
    let tests = JSON.parse(localStorage.getItem('tests'));
    let dtests =  JSON.parse(localStorage.getItem('dtests'));
    if (!tests){
      tests = await this.http.get<any>(this.urlEndPoint + '/api/test').toPromise();
      dtests = await this.http.get<any>(this.urlEndPoint + '/api/test-dynamic').toPromise();
      localStorage.setItem('tests', JSON.stringify(tests))
      localStorage.setItem('dtests', JSON.stringify(dtests))

    }

    //Filtrar por ward y por servicio
    dtests = dtests.filter (
      test => {
        if (test.limitedByWard != null && test.limitedByPriority == null){
          return test.limitedByWard.includes(serviceType)
        }
        if(test.limitedByWard == null && test.limitedByPriority != null){
          return test.limitedByPriority.includes(priorityLevel)
        }
        if(test.limitedByWard != null && test.limitedByPriority != null){
          return test.limitedByPriority.includes(priorityLevel) && test.limitedByWard.includes(serviceType)
        }
      }
    )

    return tests.concat(dtests);
  }

  getTestsFilteredByContainer(ids){
      const params = new URLSearchParams();
      params.set('ids', ids.toString());
      return this.http.get<any>(this.urlEndPoint + '/api/filtered-test?' + params.toString())

  }

  
}
